import { EmailDto } from '@dhl/mdp-api'
import type { Email } from '~/common/model/emails'

export const convertToEmailDto = (address: Email): EmailDto => ({
  address,
})
